



import React from 'react'
import './CSS/CampusCaseStudy.css'




const CampusCaseStudy = () => {
  return (
<>


<div className='campus-case-study-container'>
    <div className='campus-case-study-wrapper'>

        <div><h3> React Native College University Mobile App Case Study</h3></div>
    </div>

    <div className='campus-case-overview-wrapper'>
        <div><h3>Why Did I Create This Project</h3></div>

        <div className='campus-case-text-wrapper'>
            <div><p> I had an idea to create a mobile application for college students
             on campus to have access and resources to their local college.</p></div>
        </div>
    </div>

    <div className='campus-case-overview-wrapper'>
        <div><h3>Project Statement</h3></div>

        <div className='campus-case-text-wrapper'>
            <div><p>  with brainstorming on how to make this work, I think the audience in different age groups
             will like this type of 
            project because it gives them a glimpse of articles and other things that they can have access to as students.</p></div>
        </div>
    </div>

    <div className='campus-case-overview-wrapper'>
        <div><h3>Tech Stack</h3></div>

        <div className='campus-case-text-wrapper'>
            <div><p>Languages Used | Frameworks | Tools - React Native, React.js, Stylesheet API, other tools</p></div>
        </div>
    </div>

    <div className='campus-case-overview-wrapper'>
        <div><h3>Challenges & Learnings</h3></div>

        <div className='campus-case-text-wrapper'>
            <div><p>  the challenges for this project was the routing, pagination for the user to be
             rerouted to different sections on the mobile application in the design concept layout.</p></div>
        </div>
    </div>

    <div className='campus-case-overview-wrapper'>
        <div><h3>Outcome & Impact</h3></div>

        <div className='campus-case-text-wrapper'>
            <div><p>  this react project has an impact on students that I think that have a desire to learn more about their 
            environment and to have a great experience in a mobile friendly design application that can give them information and 
            have their feedback on it</p></div>
        </div>
    </div>
</div>




</>
  )
}

export default CampusCaseStudy
